import type { MobxDocument } from '../firestore-mobx'

import type { FirebaseRepository } from './FirebaseRepository'
import { makeObservable } from 'mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreSettingsTermsAndConditions,
} from '../firestore/SettingsTermsAndConditons/schema.ts'

export class SettingsTermsAndConditions extends ObservableModelWithDecorators<FirestoreSettingsTermsAndConditions> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSettingsTermsAndConditions>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
